import { takeLatest } from "redux-saga/effects";
import { getCheckoutSaga } from "./saga";
import { POST_CHECKOUT_REQUEST } from "../consts";

// -----------------------------------CHECKOUT----------------------------------------------

export function* watchCheckout() {
  yield takeLatest(POST_CHECKOUT_REQUEST, getCheckoutSaga);
}
